import React from "react";
import { useState } from "react";
import { toast } from "react-hot-toast";
import {AiOutlineSend} from "react-icons/ai"
import api from "../config/configaxios"
import axios from "axios"
function MessageForm({mode}) {

  const [formData , setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  function changeHandler(event){
    event.preventDefault();
    setFormData((prev) =>{
      return{
        ...prev,
        [event.target.name] :event.target.value
      }
    })
  }
  function resetForm() {
    setFormData({
      name: "",
      email: "",
      subject: "",
      message: "",
    });
  }
  let data;
  
  const submitHandler= async(event)=>
  {
    event.preventDefault();
   
    // api
    //   .post(`/api/v1/messageform`, formData )
    //   .then((response) => {
    //     console.log(response);
        
       
    //   })
    //   .catch((error) => {
    //     console.log(error.response);
       
    //   });
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
       data = await axios.post(
        "http://localhost:4000/api/v1/messageform",
        {
          formData,
        },
        config
      );
          toast.success("message sent ");
          resetForm();
          console.log(data)
          
    
      }
      catch (error) {
       toast.success("message sent ");
        resetForm();
    }


    
  }

  return (
    <div className="">
      <form onSubmit={submitHandler}>
        <div className=" flex flex-col space-y-9 mt-20">
          <div className="flex  lg:flex-row flex-col  lg:space-x-14  space-y-9 ">
            <label
              className={` mt-9 h-[78px] lg:w-[12.5rem] md:w-[28rem] sm:w-[25rem] border-2 border-deep  rounded-md p-2 hover:border-[#e83810]   inputbg${mode}
              `}
            >
              <p className="text-[0.875rem] text-richblack-5 mt-2 px-1 leading-[1.375rem]">
                Name<sup className=" text-[#9f4343]">*</sup>
              </p>
              <input
                required
                type="text"
                name="name"
                onChange={changeHandler}
                value={formData.name}
                className={` h-[22px]  w-full border-none outline-none leading-[1.375rem]  p-2  inputbg${mode}`}
              />
            </label>
            <label
              className={`  h-[78px]  lg:w-[12.5rem] md:w-[28rem] sm:w-[25rem]  border-2 border-deep  rounded-md p-2 hover:border-[#e83810]   inputbg${mode}
              `}
            >
              <p className="text-[0.875rem] text-richblack-5 mt-1 px-1 leading-[1.375rem]">
                Email Address<sup className="text-[#9f4343]">*</sup>
              </p>
              <input 
                required       
                type="email"
                name="email"
                onChange={changeHandler}
                value={formData.email}
                className={` w-full border-none outline-none leading-[1.375rem] p-2  inputbg${mode}`}
              />
            </label>
          </div>
          <div
            className={` md:w-[28rem] sm:w-[25rem] border-2 border-deep rounded-md p-2  hover:border-[#e83810] inputbg${mode} h-[78px]`}
          >
            <label className=" rounded-md ">
              <p className="text-[0.875rem] text-richblack-5 pt-2 px-1 leading-[1.375rem]">
                subject<sup className="text-[#9f4343]">*</sup>
              </p>
              <input
                required
                type="text"
                name="subject"
                onChange={changeHandler}
                value={formData.subject}
                className={` h-[25px] w-full border-none outline-none leading-[1.375rem] p-2  inputbg${mode}`}
              />
            </label>
          </div>
          <div
            className={` md:w-[28rem] sm:w-[25rem] border-2  border-deep rounded-md p-2 h-[230px] hover:border-[#e83810] inputbg${mode}`}
          >
            <label className=" rounded-md ">
              <p className="text-[0.875rem] text-richblack-5 mt-2 px-1 leading-[1.375rem]">
                Messages<sup className="text-[#9f4343]">*</sup>
              </p>
              <textarea
                required
                name="message"
                onChange={changeHandler}
                rows={6}
                cols={57}
                value={formData.message}
                className={`  w-full border-none outline-none leading-[1.375rem] p-2  inputbg${mode}`}
              />
            </label>
          </div>
          <div className=" transition-all relative ">
            <button className="red-btn rounded-lg pl-5 ">
              {" "}
              Send Messages{" "}
            </button>
            <div className=" absolute z-[50]  left-[120px] md:left-[138px] top-[19px]">
              <AiOutlineSend color="black" className="hover:text-deep " />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default MessageForm;
